import React from 'react';
import NO_AVA from 'styles/img/no-ava-card.png'
import {Link} from 'react-router-dom';
import {inject} from 'mobx-react';
const COLOR = '#039ee5';

@inject('SponsorStore')
export default class Item extends React.Component {


  linkPath = () => {
    const {sponsorId} = this.props.SponsorStore || null;
    if (sponsorId) {
      return `/${sponsorId}/details/${this.props.data.id}`;
    } else if(this.props.data.workshop_type === 'live') {
      return `/details/webinar/${this.props.data.id}`;
    } else if(this.props.data.workshop_type === 'group_supervision') {
      return `/details/public_webinars/${this.props.data.id}`;
    } else if(this.props.data.workshop_type === 'public_workshops') {
      return `/details/public_workshops/${this.props.data.id}`;
    } else {
      return `/details/online/${this.props.data.id}`;
    }
  }

  render(){
    return(
      <div className="col-12 col-md-6">
        <div className="card regular card-bottom-gutter">
          <div className="card-top-wrap">
            <div className="card-head">
              <div className="card-head-top">
                <div className="card-head-avatar-holder">
                  <div className="card-head-avatar">
                    {this.props.data.provider_logo_url ?
                      <img src={this.props.data.provider_logo_url} alt="avatar"/> :
                      <img src={NO_AVA} alt="avatar"/>
                    }
                  </div>
                  <div className="card-head-name-holder">
                    <span className="card-head-title">PROVIDED BY</span>
                    <span className="card-head-name">{this.props.data.provided_by}</span>
                  </div>
                </div>
              </div>
              <p className="card-title">{this.props.data.title}</p>
            </div>
            <div className="card-content">
              <p className="card-desc">{this.props.data.summary ? this.props.data.summary : this.props.data.description}</p>
            </div>
          </div>
          <div className="card-footer">
            <div className="card-footer-bottom">
              <ul className="card-info" style={{display: 'inline'}}>
                <li>
                  <ul className="suitableFor">
                    <li key="wdw"> <p className="card-info-title">Suitable for: </p></li>
                    {this.props.data.target_audience.map( (el,i) =>
                      <li key={i}><span style={{color: COLOR, marginLeft: 1}}>{el}</span></li>
                    )}
                  </ul>
                </li>
                <li>
                  <p className="card-info-title" key="info">
                    CPD Hours:
                    <span className="card-info-sub" style={{marginLeft: 8, color: COLOR}}>
                    {this.props.data.cpd_hours ? this.props.data.how_many_hours : 'Check with provider'}
                  </span>
                  </p>
                </li>
                <li>
                  <p className="card-info-title" key="modules">
                    Modules:
                    <span className="card-info-sub" style={{color: COLOR, marginLeft: 8}}>
                    {this.props.data.modules_count ? this.props.data.modules_count : CLOSE_ICON}
                  </span>
                  </p>
                </li>
              </ul>
              <Link to={this.linkPath()} className="btn card-btn bordered prime">
                IN PROGRESS
              </Link>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
const CLOSE_ICON = (
  <svg  width="10" height="9">
    <path fill="#FF524F" fillRule="evenodd" d="M2.292.759L.947 2.104l2.7 2.7-2.7 2.701L2.292 8.85l2.701-2.701 2.7 2.701 1.346-1.345-2.701-2.701 2.701-2.7L7.693.759l-2.7 2.7-2.701-2.7"/>
  </svg>
);



// WEBPACK FOOTER //
// ./src/components/in_progress/Item.jsx